import React from 'react';
import { Button, Divider, Center, Box } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom';
import { Logout } from './auth/Auth';
import MuteToggle from './MuteToggle';

const ProtectedHeader = () => {
    return (
      <div>
    <Divider sx={{ borderBottomWidth: '2px', borderColor: 'teal' }} />
      <Box p="4" position="sticky" bottom="0" bg="white" zIndex="banner">
        <Button as={RouterLink} to="/agents" variant="ghost" size="sm" position="absolute" left="4" top="50%" transform="translateY(-50%)">
          Agents
        </Button>
        <Center>
          <Logout textAlign="center" />
        </Center>
        <MuteToggle position="absolute" right="4" top="50%" transform="translateY(-50%)" />
      </Box>
      </div>
    );
};

export default ProtectedHeader;
